export default "__VITE_ASSET__jZP45_BP__"